import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "language-section" }
const _hoisted_3 = { class: "languages" }
const _hoisted_4 = { class: "lang-header" }
const _hoisted_5 = { class: "lang-info" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "lang-name" }
const _hoisted_8 = { class: "level" }
const _hoisted_9 = { class: "progress-bar" }
const _hoisted_10 = ["innerHTML", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.$t('cv.languages')), 1),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languages, (lang) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "lang-card",
            key: lang.name
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (lang.flag)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: lang.flag,
                      alt: lang.name + ' flaga',
                      class: "flag"
                    }, null, 8, _hoisted_6))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_7, _toDisplayString(lang.name), 1)
              ]),
              _createElementVNode("span", _hoisted_8, _toDisplayString(lang.level), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", {
                class: "progress",
                style: _normalizeStyle({ width: lang.percent + '%' })
              }, null, 4)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lang.certs, (cert) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "cert",
                innerHTML: `${_ctx.$t('cv.certificate')} ${cert.level}`,
                key: cert.link,
                onClick: ($event: any) => (_ctx.open(cert.link))
              }, null, 8, _hoisted_10))
            }), 128))
          ]))
        }), 128))
      ])
    ])
  ], 64))
}